/* eslint-disable global-require */
import assetPath from "~/utils/assetPath";

// The top-level (parent) route
const routes = {
  path: "/",

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: "/",
      load: () => import(/* webpackChunkName: 'collections' */ "./collections")
    },
    {
      path: "/topics",
      load: () => import(/* webpackChunkName: 'collections' */ "./collections")
    },
    {
      path: "/topics/:id",
      load: () => import(/* webpackChunkName: 'collections' */ "./collections")
    },
    {
      path: "/puzzles/:id",
      load: () => import(/* webpackChunkName: 'puzzles' */ "./puzzles")
    },
    {
      path: "/about",
      load: () => import(/* webpackChunkName: 'about' */ "./about")
    },
    {
      path: "/faq",
      load: () => import(/* webpackChunkName: 'faq' */ "./faq")
    },
    {
      path: "/contact",
      load: () => import(/* webpackChunkName: 'contact' */ "./contact")
    },
    {
      path: "/error",
      load: () => import(/* webpackChunkName: 'error' */ "./error")
    },
    // Wildcard routes, e.g. { path: '*', ... } (must go last)
    {
      path: "*",
      load: () => import(/* webpackChunkName: 'not-found' */ "./not-found")
    }
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title ||
      "Play Free Online Jigsaw Puzzle Games"}`;
    route.description =
      route.description ||
      "Jigsaw Puzzle is a classic jigsaw game. Choose from over 500.000 stunning pictures. Choose a difficulty between 11 and 625 pieces. Play online or download for Windows™ or Mac™.";
    route.image = `https://online-jigsaw-puzzles.com${route.image ||
      assetPath("frontpage_desktop", "jpg")}`;
    route.url = `https://online-jigsaw-puzzles.com${route.pathname || ""}`;

    return route;
  }
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: "/error",
    action: require("./error").default
  });
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js